import { setCaseIdData } from '@/store';
import { api } from '../core';

export interface CaseRegisterResponse {
  caseId: string;
}

type CaseRegisterProps = {
  abortController?: AbortController;
};

const caseRegisterApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseRegister: builder.query<CaseRegisterResponse, CaseRegisterProps>({
      query: ({ abortController = new AbortController() }: CaseRegisterProps) => ({
        url: `case/register`,
        method: 'POST',
        body: {},
        signal: abortController.signal
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data?.caseId) {
            dispatch(setCaseIdData(data.caseId));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseRegister in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseRegisterQuery } = caseRegisterApi;
